import useAirportTransferUpsell from './useAirportTransferUpsell'
import useCarHireUpsell from './useCarHireUpsell'
import useFlightUpsell from './useFlightUpsell'
import useInsuranceBookingProtectionUpsell from './useInsuranceBookingProtectionUpsell'
import useInsuranceUpsell from './useInsuranceUpsell'
import useTourUpsell from './useTourUpsell'

type AllUpsellResult = Pick<ReturnType<typeof useAllUpsells>, 'tour' | 'insurance' | 'insuranceBookingProtection' | 'airportTransfer' | 'carHire' | 'flight'>

function anyUpsellsEnabed(upsells: AllUpsellResult): boolean {
  const {
    tour: { tourUpsellEnabled },
    insurance: { insuranceUpsellEnabled },
    insuranceBookingProtection: { insuranceBookingProtectionUpsellEnabled },
    flight: { flightUpsellEnabled },
    airportTransfer: { airportTransferUpsellEnabled },
    carHire: { carHireUpsellEnabled },
  } = upsells
  return tourUpsellEnabled || insuranceUpsellEnabled || insuranceBookingProtectionUpsellEnabled || flightUpsellEnabled || airportTransferUpsellEnabled || carHireUpsellEnabled
}

function anyUpsellsLoading(upsells: AllUpsellResult): boolean {
  const {
    tour: { tourDataLoading },
    insurance: { insuranceDataLoading },
    insuranceBookingProtection: { insuranceBookingProtectionDataLoading },
    flight: { flightDataLoading },
    airportTransfer: { airportTransferDataLoading },
    carHire: { carHireDataLoading },
  } = upsells
  return tourDataLoading || insuranceDataLoading || insuranceBookingProtectionDataLoading || flightDataLoading || airportTransferDataLoading || carHireDataLoading
}

function useAllUpsells(order: App.Order) {
  const tour = useTourUpsell(order)
  const insurance = useInsuranceUpsell(order)
  const insuranceBookingProtection = useInsuranceBookingProtectionUpsell(order)
  const flight = useFlightUpsell(order)
  const airportTransfer = useAirportTransferUpsell(order)
  const carHire = useCarHireUpsell(order)

  const upsells = {
    tour,
    insurance,
    insuranceBookingProtection,
    flight,
    airportTransfer,
    carHire,
  }

  const anyUpsellEnabled = anyUpsellsEnabed(upsells)
  const anyUpsellLoading = anyUpsellsLoading(upsells)
  return {
    ...upsells,
    anyUpsellEnabled,
    anyUpsellLoading,
  }
}

export default useAllUpsells
